// hooks/playground/usePLLineItemDetails.js
import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const plLineItemQueryDefaults = {
  staleTime: 1000 * 60 * 0,     // 5 minutes
  gcTime: 1000 * 60 * 0,       // 30 minutes
  retry: 2,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
};

/**
 * Hook to fetch transaction-level details for a specific P&L line item
 *
 * @param {string} accountId - QuickBooks account ID
 * @param {number} year - Year to fetch data for
 * @param {string} accountingMethod - "Accrual" or "Cash"
 * @param {boolean} enabled - Whether the query should run
 */
export const usePLLineItemDetails = (
  accountId,
  year,
  accountingMethod = 'Accrual',
  enabled = false
) => {
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: [
      'plLineItemDetails',
      accountId,
      year,
      accountingMethod,
    ],
    queryFn: async () => {
      const response = await apiService.get(
        `${ENDPOINTS.PL_LINE_ITEM_DETAILS}/${accountId}`,
        {
          year,
          accounting_method: accountingMethod,
          use_cache: true,
        }
      );
      console.log(response)

      return response;
    },
    enabled: enabled && !!accountId,
    ...plLineItemQueryDefaults,
  });

  return {
    // Data - FIX: Backend returns 'account_info', not 'account'
    account: data?.account_info || null,  // Changed from data?.account
    monthlyTotals: data?.monthly_totals || [],
    transactions: data?.transactions || [],
    metadata: data?.metadata || {},  // Added metadata

    // Loading states
    loading: isLoading,
    refreshing: isFetching,

    // Error handling
    error: isError
        ? error?.message || 'Failed to load line item details'
        : null,
    isError,

    // Status
    initialized: !!data,

    // Actions
    refetch,
    };
};
